  import React from 'react'
  import { Link } from 'react-router-dom'
  import web_image from '../images/web_image'
  import hridayam from '../images/websites/hridayam'
  import nareshphoto from '../images/websites/nareshphoto'
  import wealthcreation from '../images/websites/wealthcreation'
  import aditi_image from '../images/clients/aditi_image'

  import web_design_development from '../images/websites/web_design_development.jpg'

  import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
  import 'react-tabs/style/react-tabs.css';

  import Home_page_BG_1 from '../images/Home_page_BG_1'

  import FileDownload from 'js-file-download'
  import 'owl.carousel/dist/assets/owl.carousel.css';
  import 'owl.carousel/dist/assets/owl.theme.default.css';
  import ComputersCanvas from '../canvas/Computers'


  export default function Webdesigning() {


    // const slides = [
    //   {
    //     id: 1,
    //     title: 'Hridayam Hearcare Center',
    //     image: 'https://via.placeholder.com/600x400.png?text=Slide+1',
    //   },
    //   {
    //     id: 2,
    //     title: 'Slide 2',
    //     image: 'https://via.placeholder.com/600x400.png?text=Slide+2',
    //   },
    //   {
    //     id: 3,
    //     title: 'Slide 3',
    //     image: 'https://via.placeholder.com/600x400.png?text=Slide+3',
    //   },
    // ];
    return <>
    {/* <div
          class="inner-banner inner-banner_2"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)) ,
      url(https://www.analyticsinsight.net/wp-content/uploads/2020/11/Artificial-Intelligence-5.jpg)`,
          }}
        >
          <img
            src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/bg/inner-bannerdot.png"
            class="inner-bannerdot"
            alt="image"
          />
          <img
            src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/bg/inner-bannerwave.png"
            class="inner-bannerwave"
            alt="image"
          />
          <div class="container">
            <div class="row d-flex justify-content-center align-items-center text-center">
              <div class="col-md-12">
                <div class="text-center">
                  <h2 class="inner-banner-title wow fadeInLeft">
                    Top Notch Mediaworks
                  </h2>
                  <ul id="breadcrumb" class="breadcrumb gap-3">
                    <li class="breadcrumb-item">
                      <Link to="/"> Home </Link>
                    </li>
                    <li class="breadcrumb-item active">Website Development</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="bg-computer">
        {/* <video autoPlay 
    muted
    loop>
      <source src='https://www.shutterstock.com/video/clip-1027045604-abstract-neon-glow-color-4k-moving-seamless' type='video/mp4'/>
    </video> */}
  <div className="animation-computer-full">
   
        <ComputersCanvas />
        </div>
        </div>
        <div className="" style={{color:"#fff"}}>
        <div className="container mt-4" style={{color:"#fff"}}>
        <div className="row text-center">
          <h1><strong> WEB DEVELOPMENT</strong></h1>
          <p style={{color:"#fff"}}>Top notch media works helps to make all types of website for small to medium business or E-commers website.</p>
        </div>
        </div>
        <section class="project-details-area sec-mar mt-5" style={{color:"#fff"}}>
          <div class="container">
            <div class="project-details-section" id="project-details">
              <div class="container">
                <div class="row justify-contenet-center gy-5">
                  <div class="col-lg-7">
                    <div class="proj-details-single">
                      <img
                        width="960"
                        height="570"
                        src={web_image}
                        class="img-fluid wp-post-image"
                        alt=""
                        decoding="async"
                        // srcset="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/Best-Work-card-6.png 960w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/Best-Work-card-6-300x178.png 300w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/Best-Work-card-6-768x456.png 768w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/Best-Work-card-6-370x220.png 370w"
                        // sizes="(max-width: 960px) 100vw, 960px"
                      />
                      {/* <ul class="project-meta-list gap-3">
                        <li>
                          <div class="icon">
                            <img
                              src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/icons/client-icon.svg"
                              alt="image"
                            />
                          </div>
                          <div class="text">
                            <h5>Client Name</h5>
                            <p>Egens Lab</p>
                          </div>
                        </li>
                        <li>
                          <div class="icon">
                            <img
                              src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/icons/category-icon.svg"
                              alt="image"
                            />
                          </div>
                          <div class="text">
                            <h5>Category</h5>
                            <p>Books </p>
                          </div>
                        </li>
                        <li>
                          <div class="icon">
                            <img
                              src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/icons/calendar2.svg"
                              alt="image"
                            />
                          </div>
                          <div class="text">
                            <h5>Complete Date</h5>
                            <p>13 Aug, 2022</p>
                          </div>
                        </li>
                      </ul> */}
                      <ul></ul>
                      <div class="proj-details-single mt-5">
                        <h4 style={{color:"#fff"}}>
                        ALL TYPES OF WEBSITES
                        </h4>
                        <p class="para" style={{color:"#fff"}}>
                        Building and maintenance of websites; it’s the work that happens behind the scenes to make a website look great, work fast and perform well with a seamless user experience.
                        </p>
                        <div class="challenge-box">
                          <h4>Challenge During The Project</h4>
                          {/* <p class="para">
                            Quis nostrud exercitation ullamco laboris nisi ut
                            aliquip ex ea commod conse quat. Duis aute irure dolor
                            in repreh enderit in voluptate velit esse cillum
                            dolore education level of volatility.
                          </p> */}
                          <ul class="challenge-list">
                            <li>
                              Analyzing research data and identifying trends and
                              patterns
                            </li>
                            <li>
                              Conducting usability testing sessions with users
                            </li>
                            <li>Amazing Timing and Experience</li>
                            <li>
                              Gathering user feedback through surveys and
                              questionnaires
                            </li>
                          </ul>
                        </div>
                        <h4 style={{color:"#fff"}}>How It Works ?</h4>
                        <p class="para mb-0" style={{color:"#fff"}}>
                        The marketing practice of creating a name, symbol or design that identifies and differentiates a product from other products.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="proj-details-right">
                      <div class="title-area">
                        {/* <span>Books </span> */}
                        <h2 style={{color:"#fff"}}>Creative Website Design for Your Business.</h2>
                      </div>
                      <p class="para" style={{color:"#fff"}}>
                      Websites can be divided into two broad categories—static and interactive. Interactive sites are part of the Web 2.0 community of sites and allow for interactivity between the site owner and site visitors or users.
                      </p>
                      <div class="proj-details-imgs">
                        <div class="row g-4">
                          <div class="col-lg-6 col-md-6 col-sm-6 text-center">
                            <img
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/project-d1-1.png"
                              class="img-fluid"
                              alt="image"
                            />
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 text-center">
                            <img
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/project-d2.png"
                              class="img-fluid"
                              alt="image"
                            />
                          </div>
                        </div>
                      </div>
                      {/* <h3 style={{color:"#fff"}}>Client Feedback </h3> */}
                      {/* <div
                        class="testimonial-single hover-border1 wow fadeInDown"
                        data-wow-duration="1.5s"
                        data-wow-delay=".2s"
                      >
                    
                        <div class="testi-img">
                          <img
                            alt="image"
                            src={aditi_image}
                          />
                        </div>
                        <div class="testi-content">
                          <div class="testi-designation">
                            <h5>Aditi Chordiya</h5>
                          </div>
                          <p>
                          They provide very helpful services to boost up your business. Amazing experience and assured result.
                          </p>
                          <Link to="/testimonials">
                          <button type="button" class="btn--primary">Know More...</button></Link>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

        

            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-sm-6">
                  
                </div>
                <div className="col-lg-6 col-sm-6"></div>
              </div>
            </div>



                  
            {/* <!-- =============== portfolio-section end  =============== --> */}
          </div>
        </section>


  
        </div>
  <br />
  <section>
  <div className="container mt-5">
  <h1 className='mx-5'> WHAT IS WEB DEVELOPMENT? </h1>
    <div className="row mt-3">
      <div className="col-lg-8 col-md-6 col-sm-6 ">
     
<p className='para text-center'>It basically refers to building, creating and maintaining of various websites. It can includes aspects such as web designing, web publishing, web programming etc. We help you design websites that would look great, work fast and perform well with a beneficial user experience. Web development helps move your business forward by creating a web page online and reaching to the huge number of people. 
</p>

<h5 className='mt-3 text-center para' >A website is a collection of web pages which is accessible to the public on internet.
<br /> 
Websites can be divided into 5 types:- 
</h5>

<ul>
  <li className='list-styled'>
    <div className="mt-5">
    <h6>1) E-commerce websites:- <span className="para">it allows shop/purchase for products or services online.
</span></h6>
   
    </div>
  </li>
  <li className='list-styled'>
    <div className="mt-2">
    <h6>2) Personal websites:- <span className="para">These websites are for individuals who can have their online presence to voice their opinion, or related works. 

</span></h6>
   
    </div>
  </li>
  <li className='list-styled'>
    <div className="mt-2">
    <h6>3) Portfolio websites:- <span className="para">-This type of website helps you to showcase your professional work which can give you a good response. 


</span></h6>
   
    </div>
  </li>
  <li className='list-styled'>
    <div className="mt-2">
    <h6>4) Small business websites:- <span className="para">This type of websites will help you make an online presence which in turn helps you to make people aware about your company, its employees, products, ideas, cultures and services. 



</span></h6>
   
    </div>
  </li>
  <li className='list-styled'>
    <div className="mt-2">
    <h6>5) Blog websites:- <span className="para">This type of websites are regularly updated with various relevant articles,events,photos or videos which communicate ,inform, educate or entertain the audience.

</span></h6>
   
    </div>
  </li>
</ul>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-6">
        <img src={web_design_development} style={{borderRadius:'20px'}} alt="" />
        <br />
        <br />
        <br />
        <img style={{borderRadius:'20px'}} src="https://images.unsplash.com/photo-1545665277-5937489579f2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cG9ydGZvbGlvfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60" alt="" />
      </div>
    </div>
  </div>


  </section>
    </>
  }
